import { render, staticRenderFns } from "./HostingKvmOrder.vue?vue&type=template&id=3cda12ad&scoped=true&"
import script from "./HostingKvmOrder.vue?vue&type=script&lang=js&"
export * from "./HostingKvmOrder.vue?vue&type=script&lang=js&"
import style0 from "./HostingKvmOrder.vue?vue&type=style&index=0&id=3cda12ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cda12ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cda12ad')) {
      api.createRecord('3cda12ad', component.options)
    } else {
      api.reload('3cda12ad', component.options)
    }
    module.hot.accept("./HostingKvmOrder.vue?vue&type=template&id=3cda12ad&scoped=true&", function () {
      api.rerender('3cda12ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/HostingKvmOrder.vue"
export default component.exports